document.addEventListener("DOMContentLoaded", function() {
    var heading = document.querySelector(".custom-featured-colctn h3.heading-font");
    if (heading) {
        var text = heading.textContent.trim();
        var words = text.split(' ');
        if (words.length >= 2) {
            var newHTML = '<span class="featured">' + words[0] + '</span> <span class="collection">' + words.slice(1).join(' ') + '</span>';
            heading.innerHTML = newHTML;
        }
    }

    var heading4 = document.querySelector(".custom-product-sec-with-variants div#tabs-4 h3.mobile-tab-heading");
    if (heading4) {
        var text4 = heading4.textContent.trim();
        var words4 = text4.split(' ');
        var newHTML4 = words4.map(word4 => `<span>${word4}</span>`).join(' ');
        heading4.innerHTML = newHTML4;
    }

      var heading3 = document.querySelector(".custom-product-sec-with-variants  div#tabs-3a h3.mobile-tab-heading");
    if (heading3) {
        var text3 = heading3.textContent.trim();
        var words3 = text3.split(' ');
        var newHTML3 = words3.map(words3 => `<span>${words3}</span>`).join(' ');
        heading3.innerHTML = newHTML3;
    }

       var heading2 = document.querySelector(".custom-product-sec-with-variants  div#tabs-2 h3.mobile-tab-heading");
    if (heading2) {
        var text2 = heading2.textContent.trim();
        var words2 = text2.split(' ');
        var newHTML2 = words2.map(words2 => `<span>${words2}</span>`).join(' ');
        heading2.innerHTML = newHTML2;
    }
});
document.addEventListener("DOMContentLoaded", function() {
    var progressCircles = document.querySelectorAll('.proudct-info-lists-sec .progress-circle');
    progressCircles.forEach(function(circle) {
        var progress = circle.getAttribute('data-progress');
        var percentage = progress * 10; // Convert to percentage
        circle.style.setProperty('--progress', percentage);

        var valueSpan = circle.querySelector('.progress-value');
        if (valueSpan) {
            valueSpan.textContent = progress;
        }
    });
});


document.addEventListener("DOMContentLoaded", function() {
    var progressCircles = document.querySelectorAll('.product-info-lists-meta .progress-circle');
    var levelMap = {
        "Beginner": 1,
        "Intermediate": 2,
        "Advanced": 3
    };

    progressCircles.forEach(function(circle) {
        var progressText = circle.getAttribute('data-progress').trim();
        var level = levelMap[progressText];
        var percentage = (level / 3) * 100;

        circle.style.setProperty('--progress', percentage);

        var valueSpan = circle.querySelector('.progress-value');
        if (valueSpan) {
            valueSpan.textContent = level + ' out of 3';
        }

        var labelSpan = circle.querySelector('.progress-label');
        if (labelSpan) {
            labelSpan.textContent = progressText;
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    var stickyAdCartDiv = document.getElementById('sticky-ad-cart-div');
    var customProductElement = document.querySelector('.custom-product.new-prodct-templat');
    
    if (stickyAdCartDiv && customProductElement) {
        customProductElement.parentNode.insertBefore(stickyAdCartDiv, customProductElement.nextSibling);
    }
});

document.addEventListener('DOMContentLoaded', function() {
  // Select the span with the class 'collection'
  var collectionSpan = document.querySelector('.new-custom-prodct-template .custom-featured-colctn .collection');
  
  if (collectionSpan) {
    // Get the text content and split it into words
    var words = collectionSpan.textContent.split(' ');
    
    // Create a new content fragment
    var newContent = words.map(word => `<span class="word">${word}</span>`).join(' ');
    
    // Set the new content to the span
    collectionSpan.innerHTML = newContent;
  }
});





